import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPromo} from "../../services/admin.promos.service";
import { ArrowLeft, CheckCircle, Clock, Play, XCircle } from "lucide-react";
import { useToast } from "../../context/ToastContext";
import PromoDetailsView from "./PromoDetailsView"; 

export default function PromoDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  
  const [promo, setPromo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);

  const fetchDetails = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getPromo(id);
      setPromo(data);
    } catch (err) {
      showToast("Erreur lors du chargement des détails", "error");
    } finally {
      setLoading(false);
    }
  }, [id, showToast]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);



  if (loading) return <div className="loaderContainer">Chargement...</div>;
  if (!promo) return <div className="page">Promotion introuvable</div>;

  const currentStatus = promo.id_status;

  return (
    <div className="page">
      <div className="pageHeaderActions">
        <button className="btnSecondary" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Liste des promotions
        </button>

        {/* <div className="adminActions" style={{ display: 'flex', gap: '10px' }}>
        
          {currentStatus === "S01" && (
            <button className="btnAssign" onClick={() => handleStatusUpdate("S02")} disabled={actionLoading}>
              <Play size={18} /> Traiter la promotion
            </button>
          )}

          {["S01", "S02"].includes(currentStatus) && (
            <button className="btnSuccess" onClick={() => handleStatusUpdate("S03")} disabled={actionLoading}>
              <CheckCircle size={18} /> Marquer comme terminée
            </button>
          )}

          {["S01", "S02"].includes(currentStatus) && (
            <button className="btnDanger" onClick={() => handleStatusUpdate("S04")} disabled={actionLoading}>
              <XCircle size={18} /> Annuler
            </button>
          )}

          {["S03", "S04"].includes(currentStatus) && (
            <button className="btnSecondary" onClick={() => handleStatusUpdate("S01")} disabled={actionLoading}>
              <Clock size={18} /> Réouvrir le ticket
            </button>
          )}
        </div> */}
      </div>

      <PromoDetailsView tr={promo} />
    </div>
  );
}